import React from 'react';

import { useAppSelector } from '../../../redux/hooks';

import * as common from 'libs/common';

import { Layout, Dropdown, Menu, Row, Col, Avatar } from 'antd';

const WithInfoTop: React.FC = (props:any) => {
    const {Header}  = Layout;
    const currentTopMenuKey = useAppSelector((state) => state.Frame.currentTopMenuKey);
    const topMenuItems = useAppSelector((state) => state.Frame.topMenuItems);
    
    const items:any = [];
    topMenuItems.forEach((item:any) => {
        items.push({
            key  : item.menuId,
            label: item.menuNm,
        });
    });

    React.useEffect(() => {
        common.showLoading(false);
    }, []);


    const dropmenu = (
        <Menu onClick={() => {
            const param = {
                title : '위드정보 확인',
                contents: '로그아웃 하시겠습니까?',
                accept : () => {
                    common.logout();
                }
            };
            common.openConfirm(param);
        }}>
            <Menu.Item key='logout' style={{  textAlign: 'center'}} >로그아웃</Menu.Item>
        </Menu>
    );


    return (
        <Header>
            <Layout>
                <Row style={{width:'100%'}}>
                    <Col flex='0.5'>
                        <a href='/'><Col className='logoWithInfo margin-right-5'/></a>
                    </Col>
                    <Col flex='8.3'>
                        <Menu mode='horizontal' items={items} activeKey={currentTopMenuKey} onClick={item => common.setCurrLeftMenuClick(item)} selectedKeys={[currentTopMenuKey]}/>
                    </Col>
                    <Col flex='0.7'>
                        <Dropdown overlay={dropmenu} >
                            <a href='/' style={{ color:'black'}} onClick={(e) => e.preventDefault()}>
                                <label className='text-bold margin-right-5' >{common.getUserNm()}</label>
                                <Avatar size={30} style={{backgroundColor: '#00B4D8'}}>{common.getUserNm()}</Avatar>
                            </a>
                        </Dropdown>
                    </Col>
                </Row>
            </Layout>
        </Header>
    );
}

export default WithInfoTop;